import {
  buildAdebifyFilterKeySet,
  DEFAULT_ADEBIFY_AXIS,
} from 'domain/adebify/screenFilterKeys';

// Filter visibility rules for the カスタムレポート (Custom Report) screen.
//
// Source of truth: adebify/docs/要件.md §481-483 (付録E-4).
// All dimensions from Product Analysis and LTV Analysis are available as
// filter conditions. Media/ADEBiS exclusivity follows the axis toggle.
// Product filters are always all four families (per 共通ルール §524).
const getAdebifyCustomReportFilterKeys = (currentTab, filterContext = {}) => {
  const axis =
    filterContext.adebifyCustomReportAxis ||
    filterContext.axis ||
    DEFAULT_ADEBIFY_AXIS;

  return buildAdebifyFilterKeySet({ axis, currentTab });
};

export default getAdebifyCustomReportFilterKeys;
